import { createAction, props } from '@ngrx/store';

export const signOut = createAction('[Auth] Sign Out');

export const logoutRequestSucceeded = createAction(
  '[Auth] Logout Request Succeeded',
);

export const sessionExpired = createAction('[Auth] Session Expired');

export const lostNetworkConnection = createAction(
  '[Auth] Lost Network Connection',
);

export const revokeChannelPermissionsSuccess = createAction(
  '[Auth] Revoke Channel Permissions Success',
);

export const revokeChannelPermissionsFailure = createAction(
  '[Auth] Revoke Channel Permissions Failure',
);
